export enum StoryStatus {
  NOT_PUBLISHED = 0,
  PUBLISHED = 1,
}
